import expensesSlice from './expensesSlice';

export * from './thunks';

export default expensesSlice;
